import type {TemplateResult} from 'lit';
import {customElement, property, state} from 'lit/decorators.js';
import {FlywheelComponent} from '#lit/lib/component.js';
import {ImmutableComponent} from '#lit/components/mixins/immutable_component/index.js';
import type {Constructor} from '#lit/types/classes.js';
import type {Model} from './architecture.js';
import {Msg, main} from './architecture.js';
import type FlyCanvas from '../canvas/index.js';
import styles from './style.scss';

export const CANVAS_WINDOW_ELEMENT_TAG = 'canvas-window';

export type PortalRegistryItem = {
  key: string;
  template: TemplateResult;
  forceMount?: boolean;
  onClose?: () => void;
};

/**
 * A window that fills up the width of the modal.
 */
@customElement(CANVAS_WINDOW_ELEMENT_TAG)
export default class CanvasWindow extends ImmutableComponent<
  Constructor<FlywheelComponent>,
  Model,
  Msg
>({component: FlywheelComponent, main}) {
  @property({type: Boolean}) open = false;
  @property({type: Object}) $canvas?: FlyCanvas;

  @state() portalRegistry: Map<string, PortalRegistryItem> = new Map();

  get activePortal(): PortalRegistryItem | null {
    return this.model.activePortal;
  }

  openWindow(key: string) {
    this.handleUpdate(Msg.open(key));
  }

  closeWindow() {
    this.model.activePortal?.onClose?.();
    this.handleUpdate(Msg.close());
  }

  register(portal: PortalRegistryItem) {
    this.portalRegistry.set(portal.key, portal);
    this.rerender();
  }

  static get styles() {
    return [styles];
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CANVAS_WINDOW_ELEMENT_TAG]: CanvasWindow;
  }
}
